/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserCredentialRestType = 'Password' | 'Passcode' | 'StaticCode' | 'SoftToken' | 'HardwareToken' | 'Yubikey' | 'FidoToken';

export const UserCredentialRestType = {
    Password: 'Password' as UserCredentialRestType,
    Passcode: 'Passcode' as UserCredentialRestType,
    StaticCode: 'StaticCode' as UserCredentialRestType,
    SoftToken: 'SoftToken' as UserCredentialRestType,
    HardwareToken: 'HardwareToken' as UserCredentialRestType,
    Yubikey: 'Yubikey' as UserCredentialRestType,
    FidoToken: 'FidoToken' as UserCredentialRestType
};

